import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: null,
  token: localStorage.getItem('token') || null,
  loading: false,
  academic: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginSuccess: (state, action) => {
      state.loading = false;
      state.user = action.payload.user;
      state.token = action.payload.token;
      localStorage.setItem('token', action.payload.token);
    },
    signUpSuccess: (state, action) => {
      state.loading = false;
      state.user = action.payload.user;
    },
    forgotPasswordSuccess: (state, action) => {
      state.loading = false;
    },
    resetPasswordSuccess: (state, action) => {
      state.loading = false;
    },
    academicSuccess: (state, action) => {
       state.loading = false;
       state.academic = action.payload.academic;
    },
    logout: (state) => {
      state.user = null;
      state.token = null;
      localStorage.clear();
    },
    setLoading: (state, action) => {
      state.loading = action.payload.loading;
    }
  },
});

export const {
  signUpSuccess,
  loginSuccess,
  forgotPasswordSuccess,
  resetPasswordSuccess,
  logout,
  setLoading,
  academicSuccess
} = authSlice.actions;

export default authSlice.reducer;